import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header';
import { NOTAMBanner } from '@/components/sections/NOTAMBanner';
import { Hero } from '@/components/sections/Hero';
import { Welcome } from '@/components/sections/Welcome';
import { Services } from '@/components/sections/Services';
import { Footer } from '@/components/layout/Footer';
import homepageData from '@/data/homepage.json';
import type { Homepage } from '@/data/types';

export function Index() {
  const { siteData } = useSiteData();
  const homepage = homepageData as Homepage;

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        
        {/* Open Graph tags */}
        <meta property="og:title" content={siteData.title} />
        <meta property="og:description" content={siteData.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.minutemanairfield.com" />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={siteData.title} />
        <meta name="twitter:description" content={siteData.description} />
        
        {/* Additional SEO */}
        <link rel="canonical" href="https://www.minutemanairfield.com" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Minute Man Air Field" />
      </Helmet>
      
      <div className="min-h-screen bg-white">
        <Header />
        <NOTAMBanner />

        <main>
          <Hero images={homepage.hero.images} />
          <Welcome title={homepage.welcome.title} />
          <Services services={homepage.services} />
        </main>

        <Footer />
      </div>
    </>
  );
}